import { Link } from '@tanstack/react-router';
import { usePageHeaderProps } from '@/shared/layout/page-header/hooks';
import type { PageHeaderProps } from '@/shared/layout/page-header/types';

export function PageHeader(props: PageHeaderProps) {
  const {
    rootProps,
    breadcrumbListProps,
    breadcrumbSeparatorProps,
    breadcrumbs,
    rowProps,
    titleProps,
    title,
    descriptionProps,
    description,
    actionsProps,
    actions,
  } = usePageHeaderProps(props);

  return (
    <header {...rootProps}>
      {breadcrumbs.length > 0 ? (
        <nav {...breadcrumbListProps}>
          {breadcrumbs.map((crumb) => (
            <span key={crumb.key} className="contents">
              {crumb.to ? (
                <Link to={crumb.to} {...crumb.props}>
                  {crumb.label}
                </Link>
              ) : (
                <span {...crumb.props} aria-current={crumb.isLast ? 'page' : undefined}>
                  {crumb.label}
                </span>
              )}
              {crumb.isLast ? null : (
                <span {...breadcrumbSeparatorProps}>/</span>
              )}
            </span>
          ))}
        </nav>
      ) : null}
      <div {...rowProps}>
        <div className="flex flex-col gap-0.5">
          <h1 {...titleProps}>{title}</h1>
          {description ? <p {...descriptionProps}>{description}</p> : null}
        </div>
        {actions ? <div {...actionsProps}>{actions}</div> : null}
      </div>
    </header>
  );
}

export { usePageHeaderProps } from '@/shared/layout/page-header/hooks';
export type { PageHeaderCrumb, PageHeaderProps } from '@/shared/layout/page-header/types';
